<div class="flex flex-col gap-4">
    <form [formGroup]="formGroupRepresentatives" class="flex flex-row gap-4 flex-wrap justify-between">
        <div class="flex flex-row flex-wrap gap-4">
            <app-input
                class="min-w-80"
                formControlName="searchTerm"
                label="Name"
                [startIcon]="searchIcon"
                placeholder="Search by name"
                id="input-search-term-filter"
            ></app-input>

            <app-select-multiple
                class="min-w-72"
                formControlName="selectedCommittees"
                label="Committee"
                [options]="committeeOptions"
                [loading]="loading"
                [showFilter]="true"
                id="select-committee-filter"
            ></app-select-multiple>

            <app-select-multiple 
                class="min-w-72"
                formControlName="selectedRoles"
                label="Roles"
                [options]="roleOptions"
                [loading]="loading"
                id="select-role-filter"
            ></app-select-multiple>
        
        
            <div class="flex items-center">
                <button
                    id="btn-reset-filters"
                    type="button"
                    class="flex items-center pt-4 btn btn-neutral"
                    (click)="resetFilters()"
                >
                    <span class="material-symbols-rounded">{{ close }}</span
                    >Clear All Filters
                </button>
            </div>
        </div>

        <div class="flex items-center">
            <app-button-export-representatives
                *ngIf="!loading && representatives && representatives.length > 0"
                [data]="tableComponent.dataSource.filteredData">
            </app-button-export-representatives>
        </div>

    </form>

    <app-table
        [loading]="loading"
        [data]="tableData"
        [columns]="tableColumns"
        [filters]="tableFilters"
        [pageSize]="50"
        [id]="tableId" />
        
</div>